<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- FORMULÁRIO -->
<div *ngIf="!loading" class="h-[calc(100dvh-10rem)] max-w-[624px] mx-auto mt-4">
  <form [formGroup]="groupForm" (ngSubmit)="submit()">

    <!-- HEADER -->
    <div class="border-b pb-4">
      <p class="font-medium text-base text-westetics-neutral-950">
        Novo Grupo de Clínicas
      </p>
      <p class="text-sm text-westetics-neutral-800 mt-2">
        Preencha o nome do grupo para criá-lo
      </p>
    </div>

    <!-- NOME DO GRUPO -->
    <div class="border-b pb-4 mt-4">
      <div class="w-full">
        <label for="name" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
          Nome do Grupo*
        </label>
        <input
          type="text"
          id="name"
          formControlName="name"
          class="bg-gray-50 border border-gray-300 text-westetics-neutral-800 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
          placeholder="Ex: Franquia São Paulo"
        />
        <span
          class="text-red-600 text-sm mt-1"
          *ngIf="groupForm.controls['name']?.invalid && groupForm.controls['name']?.touched">
          Insira um nome válido (mínimo 2 caracteres).
        </span>
      </div>
    </div>

    <!-- BOTÕES -->
    <div class="flex justify-end gap-3 mt-6">
      <button
        type="button"
        (click)="cancel()"
        class="cursor-pointer text-westetics-purple-800 hover:text-white border border-westetics-purple-800 hover:bg-westetics-purple-800 font-medium rounded-lg px-6 py-2 transition-colors">
        Cancelar
      </button>
      <button
        type="submit"
        class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white cursor-pointer font-medium rounded-lg px-6 py-2 transition-colors">
        Criar Grupo
      </button>
    </div>
  </form>
</div>
